import LoginForm from "../components/LoginForm"
import { useRouter } from "next/router"

const Login = () => {
  const router = useRouter()
  const switchToSignup = () => router.push("/signUp")

  return <LoginForm switchToSignup={switchToSignup} />
}

export default Login
